import React from 'react';
import './RotateDeviceNotice.css';

const RotateDeviceNotice = () => (
  <div className="rotate-notice-root">
    <div className="rotate-notice-icon">
      {/* Icône SVG rotation */}
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="12" width="24" height="16" rx="4" fill="#F5F6F8" stroke="#E5E7EB" strokeWidth="2"/>
        <path d="M20 8V4M20 4L16 8M20 4L24 8" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
    <div className="rotate-notice-text">
      For the best experience, please rotate your device to landscape mode.
    </div>
  </div>
);

export default RotateDeviceNotice; 